import { User } from '@/lib/core/interfaces/user.types'

export const getAvatarColorSeed = (userData: Pick<User, 'firstName' | 'lastName' | 'email'>) =>
  `${userData.firstName}${userData.lastName || userData.email}`

export const getAvatarInitial = (firstName: string) => firstName.slice(0, 1)

/**
 * Resolves the label shown in the topbar fleet pill. Prefers the current
 * organisation/fleet name, falling back to the user's display name so the pill
 * never renders empty.
 */
export const getFleetName = (
  userData?: Pick<User, 'firstName' | 'lastName' | 'email' | 'organization'>,
): string => {
  if (!userData) {
    return ''
  }

  const organizationName = userData.organization?.name?.trim()

  if (organizationName) {
    return organizationName
  }

  const fullName = `${userData.firstName ?? ''} ${userData.lastName ?? ''}`.trim()

  return fullName || userData.email || ''
}
